const styles = {
  root: {
    maxWidth: 400,
    flexGrow: 1,
  },
};

export default styles;
